export default __webpack_public_path__ + "static/media/acct-position-modal.5afffa7c.png";